module.exports = __webpack_public_path__ + "img/ai-bg.6db11434.png";